import { Label, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 350px)",
  },
  error: {
    color: "red",
    fontSize: "17px",
    fontWeight: "bold",
  },
});
const NoDataFound = () => {
  const styles = useStyles();
  return (
    <div className={styles.emptyState} data-testid="no-data-found">
      <Label className={styles.error}>
        There are no active records - click Add New to create a new record
      </Label>
    </div>
  );
};

export default NoDataFound;
